import { api } from "../../api";
import { v2ApiPath } from "../v2ApiPath";

const manifestsV2Api = api.injectEndpoints({
  tagTypes: ["ManifestsV2"],
  endpoints: (builder) => ({
    getManifestsV2: builder.query({
      query: (params = {}) => ({
        url: v2ApiPath("manifests"),
        method: "GET",
        params,
      }),
      providesTags: (result) => [
        { type: "ManifestsV2", id: "LIST" },
        ...((result?.manifests || []).map((manifest) => ({
          type: "ManifestsV2",
          id: manifest._id,
        })) || []),
      ],
    }),
    createManifestV2: builder.mutation({
      query(body) {
        return {
          url: v2ApiPath("manifests"),
          method: "POST",
          body,
        };
      },
      invalidatesTags: [{ type: "ManifestsV2", id: "LIST" }],
    }),
    getManifestV2: builder.query({
      query: ({ id }) => ({
        url: v2ApiPath(`manifests/${id}`),
        method: "GET",
      }),
      transformResponse: (response) => response.data,
      providesTags: (_result, _error, { id }) => [{ type: "ManifestsV2", id }],
    }),
    updateManifestV2: builder.mutation({
      query: ({ id, body }) => ({
        url: v2ApiPath(`manifests/${id}`),
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "ManifestsV2", id },
        { type: "ManifestsV2", id: "LIST" },
      ],
    }),
    evaluateManifestV2Gate: builder.mutation({
      query: ({ id, body = {} }) => ({
        url: id
          ? v2ApiPath(`manifests/${id}/evaluate-gate`)
          : v2ApiPath("manifests/evaluate-gate"),
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateManifestV2Mutation,
  useGetManifestV2Query,
  useGetManifestsV2Query,
  useUpdateManifestV2Mutation,
  useEvaluateManifestV2GateMutation,
} = manifestsV2Api;
